export const PLACE_TYPES_FETCHED = 'PLACE_TYPES_FETCHED';
export const PLACE_TYPE_ADD = 'PLACE_TYPE_ADD';
export const PLACE_TYPE_UPDATE = 'PLACE_TYPE_UPDATE';
export const PLACE_TYPE_REMOVE = 'PLACE_TYPE_REMOVE';
export const EXTEND_PLACE_TYPE = 'EXTEND_PLACE_TYPE';
